import { useGlobalModal } from '@/hooks/useGlobalModal';
import { Suspense, type FC } from 'react';
import { CreateReportDataExtractionDialog } from '@features/reports/components/creationSection/CreateReportDataExtractionDialog';
import { getMetricUnits } from '@features/reports/utils/metricHelpers';
import useReportsVersion from '@features/reports2/hooks/useReportsVersion';
import { CreateReportModal } from './CreateReportModal';

const CreateReportModalRouterInner: FC = () => {
  const { version } = useReportsVersion();
  const { state, setModalState } = useGlobalModal('createReports');

  if (version === 'v2') {
    return <CreateReportModal />;
  }

  const defaultData = state.open ? state.defaultData : undefined;

  const initialValues = defaultData
    ? {
        devices: defaultData.devices,
        metrics: defaultData.metrics.map((m) => ({
          metricName: m.name,
          // m.unit ya es un valor del enum MetricUnit — se usa directo, con fallback a la unidad
          // por defecto del field (también MetricUnit) si no está seteada.
          unit: m.unit ?? getMetricUnits(m.name)[0]?.enum,
        })),
        meanWindow: defaultData.meanWindow ?? undefined,
        ...(defaultData.period.start.startsWith('-')
          ? { relativeDate: defaultData.period.start }
          : {
              startDate: new Date(defaultData.period.start).getTime(),
              stopDate: defaultData.period.stop
                ? new Date(defaultData.period.stop).getTime()
                : undefined,
            }),
      }
    : undefined;

  return (
    <CreateReportDataExtractionDialog
      open={state.open}
      onClose={() => setModalState({ open: false })}
      initialValues={initialValues}
    />
  );
};

export const CreateReportModalRouter: FC = () => (
  <Suspense fallback={null}>
    <CreateReportModalRouterInner />
  </Suspense>
);
